export const formatForSelect = (list: any[], publishedOnly: boolean) => {
  let newList = [...list];
  if (publishedOnly) {
    newList = newList.filter(item => item.published?.length);
  }
  return newList.map(elem => ({
    id: elem.id,
    name: elem.name,
  }));
};
